













import isMobile from 'piramis-js-utils/lib/isMobile'
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import { ChipsWithSelectData } from '../../Pi/fields/ChipsInput/types'

const SYMBOLS_LIMIT = 15

@Component({
  data() {
    return {
      isMobile
    }
  }
})
export default class ChipsTag extends Vue {
  @Prop() tag!: string | number

  @Prop() formatter!: ChipsWithSelectData['formatter']

  get stringifyTag() {
    return this.tag.toString()
  }

  get isLargerThen15Symbols() {
    return this.stringifyTag.length > SYMBOLS_LIMIT
  }

  get first15Symbols() {
    if (this.isLargerThen15Symbols) {
      return this.stringifyTag.slice(0, SYMBOLS_LIMIT) + '...'
    }

    if (typeof this.formatter === "function") {
      return this.formatter(this.stringifyTag)
    }

    return this.stringifyTag
  }
}
